import { render, staticRenderFns } from "./VeterinaryBillingPanel.vue?vue&type=template&id=47341b85&scoped=true"
import script from "./VeterinaryBillingPanel.vue?vue&type=script&lang=js"
export * from "./VeterinaryBillingPanel.vue?vue&type=script&lang=js"
import style0 from "./VeterinaryBillingPanel.vue?vue&type=style&index=0&id=47341b85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47341b85",
  null
  
)

export default component.exports